import { render, staticRenderFns } from "./SwitchAccountPopoverItem.vue?vue&type=template&id=e06005ec&"
import script from "./SwitchAccountPopoverItem.vue?vue&type=script&lang=js&"
export * from "./SwitchAccountPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports